export const nombreCompleto = (formacion = {}) => {
  const nombres = formacion.estudiante_nombres || formacion.estudianteNombres || "";
  const apellidos = formacion.estudiante_apellidos || formacion.estudianteApellidos || "";
  const full = `${nombres} ${apellidos}`.trim();
  return full || formacion.estudiante || "Sin nombre";
};

export const normalizeFormacion = (item = {}) => {
  return {
    id: item.id,
    estudianteId: item.estudiante_id ?? item.estudianteId,
    estudiante: item.estudiante || nombreCompleto(item),
    estudianteNombres: item.estudiante_nombres ?? item.estudianteNombres,
    estudianteApellidos: item.estudiante_apellidos ?? item.estudianteApellidos,
    matriculaId: item.matricula_id ?? item.matriculaId,
    codigoMatricula: item.codigo_matricula ?? item.codigoMatricula ?? item.codigo ?? "",
    cursoId: item.curso_id ?? item.cursoId,
    nivelId: item.nivel_id ?? item.nivelId,
    formacionOrigenId: item.formacion_origen_id ?? item.formacionOrigenId,
    centroFormacion: item.centro_formacion ?? item.centroFormacion ?? "",
    centro: item.centro || item.centro_nombre || item.centro_alias || "",
    estado: item.estado || "",
    fechaInicio: item.fecha_inicio ?? item.fechaInicio,
    fechaFin: item.fecha_fin ?? item.fechaFin,
    fechaAprobacion: item.fecha_aprobacion ?? item.fechaAprobacion,
    activo: item.activo === 0 || item.activo === "0" ? false : item.activo ?? true,
    createdAt: item.created_at ?? item.createdAt,
    updatedAt: item.updated_at ?? item.updatedAt,
  };
};
